module.exports = __webpack_public_path__ + "img/banner3.bb9a5078.png";